module.exports = __webpack_public_path__ + "img/poweredby.45fb7847.svg";